<template>
    <div>
        <button-white @click="open">
            Bearbeiten
        </button-white>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Austattung bearbeiten
                </template>

                <div class="flex justify-end">
                    <equipment-delete :equipment="equipment" @leaveModal="setModalFalse"></equipment-delete>
                </div>

                <input-text v-model="name" class="mb-8">
                    Name der Ausstattung
                </input-text>

                <div class="flex justify-end" v-show="!loading">
                    <button-primary @click="save">
                        <template slot="icon"><i class="fa fa-save"></i></template> Speichern
                    </button-primary>
                </div>

                <loading v-show="loading"></loading>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonWhite from "../UI/ButtonWhite.vue";
import Modal from "../Modal.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import InputText from "../UI/InputText.vue";
import Loading from "../UI/Loading.vue";
import EquipmentDelete from "./EquipmentDelete.vue";

export default {
    name: "EquipmentEdit",

    components: {Loading, InputText, ButtonPrimary, Modal, ButtonWhite, EquipmentDelete},

    props: ['equipment'],

    data: () => ({
        showModal: false,
        loading: false,
        name: '',
    }),

    methods: {

        setModalFalse(){
            this.showModal = false;
            this.$emit('updated');
        },

        open() {
            this.showModal = true;
            this.name = this.equipment.name;
        },
        save() {
            this.loading = true;
            this.$http
                .post('/admin/equipment/' + this.equipment.id, {
                    _method: 'put',
                    name: this.name,
                })
                .then(() => {
                    this.loading = false;
                    this.$emit('updated');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },

    },
}
</script>

<style scoped>

</style>